import { render } from "./userPasswordUpdate.vue?vue&type=template&id=23b13762&scoped=true"
import script from "./userPasswordUpdate.vue?vue&type=script&lang=js"
export * from "./userPasswordUpdate.vue?vue&type=script&lang=js"

import "./userPasswordUpdate.vue?vue&type=style&index=0&id=23b13762&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b13762"]])

export default __exports__